<template>
  <section class="main-scn" :style="{ backgroundImage: `url(${image})` }">
    <img :src="$getImage(`onesti-logo/onesti-logo-branco-${currentLocale}.svg`)" class="main-scn__logo" :alt="`${$t('alt.logo')} Onesti`">
    <h2 class="main-scn__title">
      <span v-for="wordObject in titleArr" :class="wordObject.isHighlighted ? 'font-condensed' : 'font-thin'">
        {{ wordObject.word }}
      </span>
    </h2>
  </section>
</template>

<script>
export default {
  name: 'MainScn',
  data () {
    return {
      titleArr: [],
      image: undefined,
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    highlightedWordIndex: {
      type: Number,
      required: true
    },
    imageUrlPath: {
      type: String,
      required: true
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  async created () {
    const titleArr = this.title.split(' ')
    this.titleArr = titleArr.map((word, index) => ({ word, isHighlighted: index === this.highlightedWordIndex }))
    this.image = await this.$getImage(this.imageUrlPath)
  }
}
</script>

<style scoped lang="sass">
@tailwind utilities

.main-scn
  @apply relative flex items-center justify-center text-white w-full h-screen
  background-color: rgba(186, 52, 105, 0.6)
  background-size: cover
  background-repeat: no-repeat
  &__logo
    @apply absolute half-l -translate-x-50 w-40
    top: 100px
    @screen xxl
      top: 240px
  &__title
    @apply text-4xl text-center
    @screen md
      @apply text-5xl

</style>
